import { render, staticRenderFns } from "./returngoods.vue?vue&type=template&id=3f7e35dd&"
import script from "./returngoods.vue?vue&type=script&lang=js&"
export * from "./returngoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports